import { useUserStore } from '~/modules/user/stores/userStore';
import { useCheckoutStore } from '~/modules/checkout/stores/checkoutStore';
import { useCart } from '~/modules/cart/uses/useCart';
import { CABINET_URL } from '~/constants/site/cabinet';
import { useVisitorStore } from '~/modules/visitors/stores/visitorStore';

export const useAuthStore = defineStore('authStore', () => {
  const isTablet = useState<boolean>('isTablet');

  const userStore = useUserStore();
  const checkoutStore = useCheckoutStore();
  const visitorStore = useVisitorStore();
  const { setupCartCount } = useCart();

  const isUserAuthorized = ref(false);
  const isAuthModalShowing = ref(false);
  const afterLoginCallback = ref<(() => void) | undefined>();

  const isUserWholesaler = computed(() => isUserAuthorized.value && userStore.userData.user_type === 'wholesale');

  const authorize = (id: number) => {
    userStore.setUserID(id);

    isUserAuthorized.value = true;
    isAuthModalShowing.value = false;

    Promise.allSettled([
      setupCartCount(),
    ]);
  };

  const unauthorize = () => {
    isUserAuthorized.value = false;

    userStore.clearUserData();
    checkoutStore.resetBonusAmount();

    Promise.allSettled([
      setupCartCount(),
      visitorStore.setupVisitorID(),
    ]);
  };

  const toggleAuth = (isShow: boolean, callback?: () => void) => {
    if (isShow && callback) {
      setAfterLoginCallback(callback);
    } else {
      clearAfterLoginCallback();
    }

    if (isTablet.value) {
      toggleAuthRoute(isShow);
    } else {
      toggleAuthModal(isShow);
    }
  };

  const toggleAuthRoute = (isShow: boolean) => {
    if (!isShow) return;

    navigateTo('/cabinet/auth');
  };

  const toggleAuthModal = (isShow: boolean) => {
    isAuthModalShowing.value = isShow;
  };

  const setAfterLoginCallback = (callback: () => void) => {
    afterLoginCallback.value = callback;
  };

  const clearAfterLoginCallback = () => {
    afterLoginCallback.value = undefined;
  };

  return {
    isUserAuthorized,
    isUserWholesaler,
    isAuthModalShowing,
    afterLoginCallback,
    toggleAuth,
    authorize,
    unauthorize,
    setAfterLoginCallback,
    clearAfterLoginCallback,
  };
});
